module.exports = __webpack_public_path__ + "static/media/file-powerpoint.bec36d0d.svg";